import styled from "styled-components"

export const Container = styled.div`
  with: 100%;
`
